import React, { useState } from 'react';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import { bool } from 'prop-types';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import PopupMessage from '@airasia/phoenix-components/components/PopupMessage';
import useWindowSize from '../../utils/windowSize';

const FallbackLanguageMessage = ({ isShow }) => {
  const [isShowMessage, setIsShowMessage] = useState(isShow);
  const { isMobileView } = useWindowSize();
  const AUTO_HIDE_TIMER = 5000;

  return (
    <PhoenixTheme>
      <PopupMessage
        isShow={isShowMessage}
        zIndex={20}
        message={translate('common.languageNotSupported')}
        autoHideDuration={AUTO_HIDE_TIMER}
        onClose={() => setIsShowMessage(false)}
        isMobile={isMobileView}
      />
    </PhoenixTheme>
  );
};

FallbackLanguageMessage.propTypes = {
  isShow: bool,
};

export default FallbackLanguageMessage;
